import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './OurHistory.css';

const OurHistory = () => {
  return (
    <section className="our-history" id="history">
      <div className="section-title-wrapper">
        <h2 className="section-title">Our History</h2>
      </div>

      <div className="history-card">
        <div className="history-text-content">
          <p className="history-description">
            We, Pravasi SNDP Yogam members, are the devotees of Sree Narayana Guru, 
            a revered saint and social reformer from Kerala, India (1854-1928). 
            The term "Pravasi", derived from Malayalam, beautifully encapsulates 
            the essence of individuals who, driven by ambition and opportunity, 
            leave their native land to reside and work in foreign territories. 
            In this context, the "Pravasi SNDP Yogam" stands as a beacon of hope 
            and support, dedicated to the well-being of these expatriates.
          </p>

          <a href="#about" className="view-more-link">
            <span>View More</span>
            <FiArrowRight size={25} color="#FFC501" />
          </a>
        </div>

        <div className="history-image">
          <img
            src={`${process.env.PUBLIC_URL}/Sndp/image-2.png`}
            alt="Sree Narayana Guru meditating"
          />
        </div>
      </div>
    </section>
  );
};

export default OurHistory;
